export default __webpack_public_path__ + "static/IvarDisplay-Regular-8c8ddd231262651263b7bce598e2d573.woff";